import React from "react";

export default function EnfantsSection({ img1 }) {
  return (
	<section id="enfants" className="section alt">
	  <div className="container split">
		<div className="split-media">
		  <img src={img1} alt="Cours enfants" loading="lazy" />
		</div>

		<div className="split-text">
		  <h2>Programme Enfants</h2>

		  <p>
			Le <strong>cours enfants</strong> est l’endroit parfait pour le
			<strong> développement</strong> de votre enfant : motricité, coordination,
			concentration et <strong>confiance en soi</strong>. Nous accueillons les enfants
			<strong> dès 5 ans</strong> dans un cadre sûr et bienveillant.
		  </p>

		  <div className="badges">
			<span className="badge">Politesse</span>
			<span className="badge">Courage</span>
			<span className="badge">Sincérité</span>
			<span className="badge">Honneur</span>
			<span className="badge">Modestie</span>
			<span className="badge">Respect</span>
			<span className="badge">Contrôle de soi</span>
			<span className="badge">Amitié</span>
		  </div>

		  <p>
			Les enfants viennent <strong>s’amuser avant tout</strong> : jeux, parcours,
			défis coopératifs et <em>ukemi</em> (apprentissage des chutes en sécurité).
			En parallèle, ils progressent techniquement : immobilisations, contrôles,
			projections adaptées à l’âge et initiation au <em>randori</em>.
		  </p>

		  <p>
			Pour ceux qui le souhaitent, nous proposons un
			<strong> accompagnement vers la compétition</strong> : règles, catégories,
			attitude sur et en dehors du tatami, et surtout <strong>respect</strong>.
		  </p>

		  <a className="btn-primary" href="#inscription">Essai gratuit</a>
		</div>
	  </div>
	</section>
  );
}
